import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down.svg'


const _hoisted_1 = { class: "border border-gray-lp-1400 rounded-xl" }
const _hoisted_2 = { class: "flex p-4 items-center gap-8" }
const _hoisted_3 = { class: "flex-1 min-w-0 flex flex-row gap-5 items-start" }
const _hoisted_4 = { class: "items-end flex flex-col gap-0.5" }
const _hoisted_5 = { class: "font-bold text-xl text-black-lp-100" }
const _hoisted_6 = { class: "font-medium text-xs text-gray-lp-600" }
const _hoisted_7 = {
  class: "flex flex-col gap-1.5",
  style: {"width":"400px"}
}
const _hoisted_8 = { class: "flex items-center w-full" }
const _hoisted_9 = { class: "flex gap-0.5 items-center w-full justify-center" }
const _hoisted_10 = { class: "font-normal text-black-lp-100 text-sm" }
const _hoisted_11 = { class: "font-normal text-gray-lp-600 text-xs" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", {
  class: "w-full h-0.5 rounded-2xl relative",
  style: {"background-color":"#F3F4F6"}
}, [
  /*#__PURE__*/_createVNode("div", { class: "h-0.5 w-10 rounded-2xl absolute left-0 bg-red-lp-2400" }),
  /*#__PURE__*/_createVNode("div", { class: "h-0.5 w-10 rounded-2xl absolute right-0 bg-red-lp-2400" })
], -1)
const _hoisted_13 = { class: "flex items-center w-full" }
const _hoisted_14 = { class: "font-semibold text-black-lp-100 text-sm" }
const _hoisted_15 = { class: "flex gap-1 items-center w-full justify-center" }
const _hoisted_16 = { class: "font-semibold text-black-lp-100 text-sm" }
const _hoisted_17 = { class: "font-semibold text-black-lp-100 text-sm" }
const _hoisted_18 = { class: "items-start flex flex-col gap-0.5" }
const _hoisted_19 = { class: "font-bold text-xl text-black-lp-100" }
const _hoisted_20 = { class: "font-medium text-xs text-gray-lp-600" }
const _hoisted_21 = { class: "font-semibold text-sm text-black-lp-100 inline-flex whitespace-nowrap" }
const _hoisted_22 = {
  key: 0,
  src: _imports_0,
  class: "w-5",
  alt: "up"
}
const _hoisted_23 = {
  key: 1,
  src: _imports_1,
  class: "w-5",
  alt: "down"
}
const _hoisted_24 = {
  key: 0,
  class: "p-2 bg-gray-lp-2800 flex flex-row w-full"
}
const _hoisted_25 = {
  key: 0,
  class: "flex flex-col gap-0.5 justify-center px-2 whitespace-nowrap"
}
const _hoisted_26 = { class: "font-normal text-xs text-gray-lp-600 text-center" }
const _hoisted_27 = { class: "flex gap-1 items-center w-full justify-center" }
const _hoisted_28 = { class: "font-medium text-xs text-black-lp-100" }
const _hoisted_29 = { class: "text-xs text-gray-lp-800 flex flex-row items-center justify-center" }
const _hoisted_30 = { class: "font-extrabold text-sm text-black-lp-100 text-center" }
const _hoisted_31 = {
  key: 1,
  class: "flex flex-row w-full"
}
const _hoisted_32 = { class: "flex gap-1 items-center w-full" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", {
  class: "w-full bg-gray-lp-1400",
  style: {"height":"1px"}
}, null, -1)
const _hoisted_34 = { class: "font-bold text-black-lp-100 text-sm whitespace-nowrap" }
const _hoisted_35 = /*#__PURE__*/_createVNode("div", {
  class: "w-full bg-gray-lp-1400",
  style: {"height":"1px"}
}, null, -1)
const _hoisted_36 = { class: "flex flex-col gap-0.5 justify-center px-2 whitespace-nowrap" }
const _hoisted_37 = { class: "font-normal text-xs text-gray-lp-600 text-center" }
const _hoisted_38 = { class: "flex gap-1 items-center w-full justify-center" }
const _hoisted_39 = { class: "font-medium text-xs text-black-lp-100" }
const _hoisted_40 = /*#__PURE__*/_createVNode("span", { class: "font-normal text-xs text-gray-lp-600" }, "|", -1)
const _hoisted_41 = { class: "font-medium text-xs text-black-lp-100" }
const _hoisted_42 = { class: "text-xs text-gray-lp-800 flex flex-row items-center gap-x-2.5" }
const _hoisted_43 = { class: "font-extrabold text-sm text-black-lp-100 text-center" }
const _hoisted_44 = /*#__PURE__*/_createVNode("div", {
  class: "w-full bg-gray-lp-1400",
  style: {"height":"1px"}
}, null, -1)
const _hoisted_45 = { class: "font-bold text-black-lp-100 text-sm whitespace-nowrap" }
const _hoisted_46 = /*#__PURE__*/_createVNode("div", {
  class: "w-full bg-gray-lp-1400",
  style: {"height":"1px"}
}, null, -1)
const _hoisted_47 = { class: "flex flex-col gap-0.5 justify-center px-2 whitespace-nowrap" }
const _hoisted_48 = { class: "font-normal text-xs text-gray-lp-600 text-center" }
const _hoisted_49 = { class: "flex gap-1 items-center w-full justify-center" }
const _hoisted_50 = { class: "font-medium text-xs text-black-lp-100" }
const _hoisted_51 = { class: "text-xs text-gray-lp-800 flex flex-row items-center" }
const _hoisted_52 = { class: "font-extrabold text-sm text-black-lp-100 text-center justify-center" }
const _hoisted_53 = {
  key: 2,
  class: "flex flex-row w-full"
}
const _hoisted_54 = { class: "flex gap-1 items-center w-full" }
const _hoisted_55 = /*#__PURE__*/_createVNode("div", {
  class: "w-full bg-gray-lp-1400",
  style: {"height":"1px"}
}, null, -1)
const _hoisted_56 = { class: "font-bold text-black-lp-100 text-sm whitespace-nowrap" }
const _hoisted_57 = /*#__PURE__*/_createVNode("div", {
  class: "w-full bg-gray-lp-1400",
  style: {"height":"1px"}
}, null, -1)
const _hoisted_58 = { class: "flex flex-col gap-0.5 justify-center px-2 whitespace-nowrap" }
const _hoisted_59 = { class: "font-normal text-xs text-gray-lp-600 text-center" }
const _hoisted_60 = { class: "flex gap-1 items-center w-full justify-center" }
const _hoisted_61 = { class: "font-medium text-xs text-black-lp-100" }
const _hoisted_62 = /*#__PURE__*/_createVNode("span", { class: "font-normal text-xs text-gray-lp-600" }, "|", -1)
const _hoisted_63 = { class: "font-medium text-xs text-black-lp-100" }
const _hoisted_64 = { class: "text-xs text-gray-lp-800 flex flex-row items-center gap-x-2.5" }
const _hoisted_65 = { class: "font-extrabold text-sm text-black-lp-100 text-center" }
const _hoisted_66 = {
  key: 1,
  class: "w-full flex flex-col"
}
const _hoisted_67 = {
  key: 1,
  class: "flex flex-col gap-0.5 justify-center px-2 whitespace-nowrap"
}
const _hoisted_68 = { class: "font-normal text-xs text-gray-lp-600 text-center" }
const _hoisted_69 = { class: "flex gap-1 items-center w-full justify-center" }
const _hoisted_70 = { class: "font-medium text-xs text-black-lp-100" }
const _hoisted_71 = { class: "text-xs text-gray-lp-800 flex flex-row items-center justify-center" }
const _hoisted_72 = { class: "font-extrabold text-sm text-black-lp-100 text-center" }
const _hoisted_73 = { class: "flex flex-col gap-0.5 justify-center px-2 whitespace-nowrap flex-shrink-0" }
const _hoisted_74 = { class: "font-normal text-xs text-gray-lp-600 text-center" }
const _hoisted_75 = { class: "flex gap-1 items-center w-full justify-center" }
const _hoisted_76 = { class: "font-medium text-xs text-black-lp-100" }
const _hoisted_77 = { class: "text-xs text-gray-lp-800 flex flex-row items-center justify-center" }
const _hoisted_78 = { class: "flex gap-1 items-center w-full justify-center" }
const _hoisted_79 = { class: "font-medium text-xs text-black-lp-100" }
const _hoisted_80 = /*#__PURE__*/_createVNode("span", { class: "font-normal text-xs text-gray-lp-600" }, "|", -1)
const _hoisted_81 = { class: "font-medium text-xs text-black-lp-100" }
const _hoisted_82 = { class: "text-xs text-gray-lp-800 flex flex-row items-center gap-x-2.5 justify-center" }
const _hoisted_83 = { class: "font-extrabold text-sm text-black-lp-100 text-center" }
const _hoisted_84 = { class: "flex-1 flex gap-1 items-center min-w-0" }
const _hoisted_85 = /*#__PURE__*/_createVNode("div", {
  class: "w-full bg-gray-lp-1300",
  style: {"height":"1px"}
}, null, -1)
const _hoisted_86 = { class: "font-bold text-black-lp-100 text-sm whitespace-nowrap flex-shrink-0" }
const _hoisted_87 = {
  class: "w-full bg-gray-lp-1300 relative text-gray-lp-1300",
  style: {"height":"1px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("span", _hoisted_5, _toDisplayString(_ctx.formatTime(_ctx.data.departureDate)), 1),
          _createVNode("span", _hoisted_6, _toDisplayString(_ctx.formatShortDate(_ctx.data.departureDate)), 1)
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("img", {
              src: require(`@/app/ui/assets/svg/flight_takeoff.svg`),
              alt: "flight_takeoff"
            }, null, 8, ["src"]),
            _createVNode("div", _hoisted_9, [
              _createVNode("span", _hoisted_10, _toDisplayString(_ctx.formatFlightDuration(_ctx.data.departureDate, _ctx.data.arrivalDate)) + " •", 1),
              _createVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("cargoV2.components.cardFlight.transit", { count: _ctx.data.transitNumber })), 1)
            ]),
            _createVNode("img", {
              src: require(`@/app/ui/assets/svg/flight_land.svg`),
              alt: "flight_land"
            }, null, 8, ["src"])
          ]),
          _hoisted_12,
          _createVNode("div", _hoisted_13, [
            _createVNode("span", _hoisted_14, _toDisplayString(_ctx.data.originAirportCode), 1),
            _createVNode("div", _hoisted_15, [
              (_ctx.mapLogoPlaneLabel(_ctx.data.itineraries[0].flightNo))
                ? (_openBlock(), _createBlock("img", {
                    key: 0,
                    src: 
                  require(`@/app/ui/assets/svg/${_ctx.mapLogoPlaneLabel(
                    _ctx.data.itineraries[0].flightNo
                  )}.svg`)
                ,
                    class: "w-6 h-6",
                    alt: "logo-plane-label"
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true),
              _createVNode("span", _hoisted_16, _toDisplayString(_ctx.data.itineraries[0].flightNo), 1)
            ]),
            _createVNode("span", _hoisted_17, _toDisplayString(_ctx.data.destinationAirportCode), 1)
          ])
        ]),
        _createVNode("div", _hoisted_18, [
          _createVNode("span", _hoisted_19, _toDisplayString(_ctx.formatTime(_ctx.data.arrivalDate)), 1),
          _createVNode("span", _hoisted_20, _toDisplayString(_ctx.formatShortDate(_ctx.data.arrivalDate)), 1)
        ])
      ]),
      (_ctx.data.itineraries.length > 1)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "justify-end flex gap-1.5 items-center cursor-pointer",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openDetail && _ctx.openDetail(...args)))
          }, [
            _createVNode("span", _hoisted_21, _toDisplayString(_ctx.isOpenDetail ? _ctx.$t("cargoV2.components.cardFlight.close") : _ctx.$t("cargoV2.components.cardFlight.viewTransitDetail")), 1),
            _createVNode("div", null, [
              (_ctx.isOpenDetail)
                ? (_openBlock(), _createBlock("img", _hoisted_22))
                : (_openBlock(), _createBlock("img", _hoisted_23))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isOpenDetail && !_ctx.isGridLayout)
      ? (_openBlock(), _createBlock("div", _hoisted_24, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.itineraries, (itinerary, index) => {
            return (_openBlock(), _createBlock("div", {
              key: index,
              class: [
          index === _ctx.data.itineraries.length - 1 && 'w-full',
          index !== 0 && index < _ctx.data.itineraries.length - 1 && 'w-1/2'
        ]
            }, [
              (index === 0)
                ? (_openBlock(), _createBlock("div", _hoisted_25, [
                    _createVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("cargoV2.components.cardFlight.originCity")), 1),
                    _createVNode("div", _hoisted_27, [
                      _createVNode("span", _hoisted_28, _toDisplayString(_ctx.formatTime(itinerary.departureDate)), 1),
                      _createVNode("img", {
                        src: require(`@/app/ui/assets/svg/flight_takeoff.svg`),
                        class: "w-2 h-2",
                        alt: "flight_takeoff"
                      }, null, 8, ["src"])
                    ]),
                    _createVNode("div", _hoisted_29, [
                      _createVNode("div", null, _toDisplayString(_ctx.formatDateTransit(itinerary.departureDate)), 1)
                    ]),
                    _createVNode("span", _hoisted_30, _toDisplayString(itinerary.originAirportCode), 1)
                  ]))
                : (index === _ctx.data.itineraries.length - 1)
                  ? (_openBlock(), _createBlock("div", _hoisted_31, [
                      _createVNode("div", _hoisted_32, [
                        _hoisted_33,
                        (_ctx.mapLogoPlaneLabel(_ctx.data.itineraries[index - 1].flightNo))
                          ? (_openBlock(), _createBlock("img", {
                              key: 0,
                              src: 
                require(`@/app/ui/assets/svg/${_ctx.mapLogoPlaneLabel(
                  _ctx.data.itineraries[index - 1].flightNo
                )}.svg`)
              ,
                              alt: "logo-plane-label"
                            }, null, 8, ["src"]))
                          : _createCommentVNode("", true),
                        _createVNode("span", _hoisted_34, _toDisplayString(_ctx.data.itineraries[index - 1].flightNo), 1),
                        _hoisted_35,
                        _createVNode("div", _hoisted_36, [
                          _createVNode("span", _hoisted_37, _toDisplayString(_ctx.$t("cargoV2.components.cardFlight.transit", { count: itinerary.transitNumber })), 1),
                          _createVNode("div", _hoisted_38, [
                            _createVNode("img", {
                              src: require(`@/app/ui/assets/svg/flight_land.svg`),
                              class: "w-2 h-2",
                              alt: "flight_land"
                            }, null, 8, ["src"]),
                            _createVNode("span", _hoisted_39, _toDisplayString(_ctx.formatTime(_ctx.data.itineraries[index - 1].arrivalDate)), 1),
                            _hoisted_40,
                            _createVNode("span", _hoisted_41, _toDisplayString(_ctx.formatTime(itinerary.departureDate)), 1),
                            _createVNode("img", {
                              src: require(`@/app/ui/assets/svg/flight_takeoff.svg`),
                              class: "w-2 h-2",
                              alt: "flight_takeoff"
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("div", _hoisted_42, [
                            _createVNode("div", null, _toDisplayString(_ctx.formatDateTransit(_ctx.data.itineraries[index-1].arrivalDate || "")), 1),
                            _createVNode("div", null, _toDisplayString(_ctx.formatDateTransit(itinerary.departureDate)), 1)
                          ]),
                          _createVNode("span", _hoisted_43, _toDisplayString(itinerary.originAirportCode), 1)
                        ]),
                        _hoisted_44,
                        (_ctx.mapLogoPlaneLabel(itinerary.flightNo))
                          ? (_openBlock(), _createBlock("img", {
                              key: 1,
                              src: 
                require(`@/app/ui/assets/svg/${_ctx.mapLogoPlaneLabel(
                  itinerary.flightNo
                )}.svg`)
              ,
                              alt: "logo-plane-label"
                            }, null, 8, ["src"]))
                          : _createCommentVNode("", true),
                        _createVNode("span", _hoisted_45, _toDisplayString(itinerary.flightNo), 1),
                        _hoisted_46
                      ]),
                      _createVNode("div", _hoisted_47, [
                        _createVNode("span", _hoisted_48, _toDisplayString(_ctx.$t("cargoV2.components.cardFlight.destinationCity")), 1),
                        _createVNode("div", _hoisted_49, [
                          _createVNode("span", _hoisted_50, _toDisplayString(_ctx.formatTime(itinerary.arrivalDate)), 1),
                          _createVNode("img", {
                            src: require(`@/app/ui/assets/svg/flight_land.svg`),
                            class: "w-2 h-2",
                            alt: "flight_land"
                          }, null, 8, ["src"])
                        ]),
                        _createVNode("div", _hoisted_51, _toDisplayString(_ctx.formatDateTransit(itinerary.arrivalDate)), 1),
                        _createVNode("span", _hoisted_52, _toDisplayString(itinerary.destinationAirportCode), 1)
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_53, [
                      _createVNode("div", _hoisted_54, [
                        _hoisted_55,
                        (_ctx.mapLogoPlaneLabel(_ctx.data.itineraries[index - 1].flightNo))
                          ? (_openBlock(), _createBlock("img", {
                              key: 0,
                              src: 
                require(`@/app/ui/assets/svg/${_ctx.mapLogoPlaneLabel(
                  _ctx.data.itineraries[index - 1].flightNo
                )}.svg`)
              ,
                              alt: "logo-plane-label"
                            }, null, 8, ["src"]))
                          : _createCommentVNode("", true),
                        _createVNode("span", _hoisted_56, _toDisplayString(_ctx.data.itineraries[index - 1].flightNo), 1),
                        _hoisted_57
                      ]),
                      _createVNode("div", _hoisted_58, [
                        _createVNode("span", _hoisted_59, " Transit " + _toDisplayString(itinerary.transitNumber), 1),
                        _createVNode("div", _hoisted_60, [
                          _createVNode("img", {
                            src: require(`@/app/ui/assets/svg/flight_land.svg`),
                            class: "w-2 h-2",
                            alt: "flight_land"
                          }, null, 8, ["src"]),
                          _createVNode("span", _hoisted_61, _toDisplayString(_ctx.formatTime(_ctx.data.itineraries[index - 1].arrivalDate)), 1),
                          _hoisted_62,
                          _createVNode("span", _hoisted_63, _toDisplayString(_ctx.formatTime(itinerary.departureDate)), 1),
                          _createVNode("img", {
                            src: require(`@/app/ui/assets/svg/flight_takeoff.svg`),
                            class: "w-2 h-2",
                            alt: "flight_takeoff"
                          }, null, 8, ["src"])
                        ]),
                        _createVNode("div", _hoisted_64, [
                          _createVNode("div", null, _toDisplayString(_ctx.formatDateTransit(_ctx.data.itineraries[index-1].arrivalDate || "")), 1),
                          _createVNode("div", null, _toDisplayString(_ctx.formatDateTransit(itinerary.departureDate)), 1)
                        ]),
                        _createVNode("span", _hoisted_65, _toDisplayString(itinerary.originAirportCode), 1)
                      ])
                    ]))
            ], 2))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.isOpenDetail && _ctx.isGridLayout)
      ? (_openBlock(), _createBlock("div", _hoisted_66, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.transitGridRows, (row, rowIndex) => {
            return (_openBlock(), _createBlock("div", {
              key: rowIndex,
              class: ["flex flex-row items-center p-2", rowIndex % 2 === 0 ? 'bg-gray-lp-2800' : 'bg-white']
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(row, (item, itemIndex) => {
                return (_openBlock(), _createBlock("div", {
                  key: itemIndex,
                  class: "flex flex-row items-center flex-1"
                }, [
                  (item.isEmpty)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [], 64))
                    : (item.isDestination)
                      ? (_openBlock(), _createBlock("div", _hoisted_67, [
                          _createVNode("span", _hoisted_68, _toDisplayString(_ctx.$t("cargoV2.components.cardFlight.destinationCity")), 1),
                          _createVNode("div", _hoisted_69, [
                            _createVNode("span", _hoisted_70, _toDisplayString(_ctx.formatTime(item.itinerary.arrivalDate)), 1),
                            _createVNode("img", {
                              src: require(`@/app/ui/assets/svg/flight_land.svg`),
                              class: "w-2 h-2",
                              alt: "flight_land"
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("div", _hoisted_71, _toDisplayString(_ctx.formatDateTransit(item.itinerary.arrivalDate)), 1),
                          _createVNode("span", _hoisted_72, _toDisplayString(item.itinerary.destinationAirportCode), 1)
                        ]))
                      : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                          _createVNode("div", _hoisted_73, [
                            _createVNode("span", _hoisted_74, _toDisplayString(item.index === 0 ? _ctx.$t("cargoV2.components.cardFlight.originCity") : _ctx.$t("cargoV2.components.cardFlight.transit", { count: item.index })), 1),
                            (item.index === 0)
                              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                  _createVNode("div", _hoisted_75, [
                                    _createVNode("span", _hoisted_76, _toDisplayString(_ctx.formatTime(item.itinerary.departureDate)), 1),
                                    _createVNode("img", {
                                      src: require(`@/app/ui/assets/svg/flight_takeoff.svg`),
                                      class: "w-2 h-2",
                                      alt: "flight_takeoff"
                                    }, null, 8, ["src"])
                                  ]),
                                  _createVNode("div", _hoisted_77, _toDisplayString(_ctx.formatDateTransit(item.itinerary.departureDate)), 1)
                                ], 64))
                              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                  _createVNode("div", _hoisted_78, [
                                    _createVNode("img", {
                                      src: require(`@/app/ui/assets/svg/flight_land.svg`),
                                      class: "w-2 h-2",
                                      alt: "flight_land"
                                    }, null, 8, ["src"]),
                                    _createVNode("span", _hoisted_79, _toDisplayString(_ctx.formatTime(_ctx.data.itineraries[item.index - 1].arrivalDate)), 1),
                                    _hoisted_80,
                                    _createVNode("span", _hoisted_81, _toDisplayString(_ctx.formatTime(item.itinerary.departureDate)), 1),
                                    _createVNode("img", {
                                      src: require(`@/app/ui/assets/svg/flight_takeoff.svg`),
                                      class: "w-2 h-2",
                                      alt: "flight_takeoff"
                                    }, null, 8, ["src"])
                                  ]),
                                  _createVNode("div", _hoisted_82, [
                                    _createVNode("div", null, _toDisplayString(_ctx.formatDateTransit(_ctx.data.itineraries[item.index - 1].arrivalDate || "")), 1),
                                    _createVNode("div", null, _toDisplayString(_ctx.formatDateTransit(item.itinerary.departureDate)), 1)
                                  ])
                                ], 64)),
                            _createVNode("span", _hoisted_83, _toDisplayString(item.itinerary.originAirportCode), 1)
                          ]),
                          _createVNode("div", _hoisted_84, [
                            _hoisted_85,
                            (_ctx.mapLogoPlaneLabel(item.itinerary.flightNo))
                              ? (_openBlock(), _createBlock("img", {
                                  key: 0,
                                  src: require(`@/app/ui/assets/svg/${_ctx.mapLogoPlaneLabel(item.itinerary.flightNo)}.svg`),
                                  alt: "logo-plane-label",
                                  class: "flex-shrink-0"
                                }, null, 8, ["src"]))
                              : _createCommentVNode("", true),
                            _createVNode("span", _hoisted_86, _toDisplayString(item.itinerary.flightNo), 1),
                            _createVNode("div", _hoisted_87, [
                              _createVNode(_component_Icons, {
                                name: "arrow-up",
                                style: {"transform":"rotate(90deg)","position":"absolute","top":"-4.5","right":"-2","width":"10px","height":"10px"}
                              })
                            ])
                          ])
                        ], 64))
                ]))
              }), 128))
            ], 2))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}